import { render, staticRenderFns } from "./ShopifyProductsList.vue?vue&type=template&id=ef4d2cd0&"
import script from "./ShopifyProductsList.vue?vue&type=script&lang=js&"
export * from "./ShopifyProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports